import { render, staticRenderFns } from "./CertificateContent3.vue?vue&type=template&id=2e8c6452&scoped=true&"
import script from "./CertificateContent3.vue?vue&type=script&lang=js&"
export * from "./CertificateContent3.vue?vue&type=script&lang=js&"
import style0 from "./CertificateContent3.vue?vue&type=style&index=0&id=2e8c6452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c6452",
  null
  
)

export default component.exports